var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 12H13C11.3433 12 10 13.3433 10 15V27C10 28.6567 11.3433 30 13 30H29C30.6567 30 32 28.6567 32 27V15C32 13.3433 30.6567 12 29 12ZM29 14C29.1155 14 29.2265 14.0195 29.3295 14.0557L21 20.7195L12.6705 14.0557C12.7764 14.0186 12.8878 13.9998 13 14H29ZM29 28H13C12.7348 28 12.4804 27.8946 12.2929 27.7071C12.1054 27.5196 12 27.2652 12 27V16.0805L20.3752 22.7808C20.5577 22.927 20.7788 23 21 23C21.2212 23 21.4423 22.927 21.6248 22.7808L30 16.0805V27C30 27.2652 29.8946 27.5196 29.7071 27.7071C29.5196 27.8946 29.2652 28 29 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFEmail);
export default __webpack_public_path__ + "static/media/f-email.adfb988b94c730422d7c402a198c571c.svg";
export { ForwardRef as ReactComponent };